import React, { useState } from 'react';
import {
  CButton,
  CCol,
  CForm,
  CInput,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CRow,
  CAlert,
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { useHistory } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import axios from '../utils/axios';
import LoaderButton from '../components/LoaderButton';
import '../scss/style.scss';

const validationSchema = Yup.object({
  email: Yup.string().email().required('Required'),
  password: Yup.string().required('Required'),
});

function LoginForm({ forgotPassword, setForgotPassword }) {
  let history = useHistory();
  const [errorMessage, setErrorMessage] = useState();
  const [loading, setLoading] = useState(false);
  const { handleChange, handleSubmit, values, errors } = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema,
    onSubmit(values) {
      setLoading(true);
      onLoginHandler(values);
    },
  });

  const onLoginHandler = async (data) => {
    setErrorMessage(null);
    try {
      const response = await axios.post('/auth/login', data);
      if (response.status === 201) {
        localStorage.setItem('token', response.data.accessToken);
        setLoading(false);
        history.push('/categories');
      }
    } catch (err) {
      if (err.response.data.statusCode === 401) {
        setErrorMessage(err.response.data.message);
      }
      setLoading(false);
    }
  };

  return (
    <CForm onSubmit={handleSubmit}>
      <div className="text-center">
        <h1>Login</h1>
        <p className="text-muted">Sign In to your account</p>
      </div>
      <CRow>
        <CCol>
          <CInputGroup className="mb-3 w-75 width-xs mx-auto">
            <CInputGroupPrepend>
              <CInputGroupText>
                <CIcon name="cil-user" />
              </CInputGroupText>
            </CInputGroupPrepend>
            <CInput
              type="text"
              placeholder="Username"
              autoComplete="username"
              name="email"
              value={values.email}
              onChange={handleChange}
              invalid={errors.email ? true : false}
            />
          </CInputGroup>
        </CCol>
      </CRow>
      <CRow>
        <CCol>
          <CInputGroup className="mb-4 w-75 width-xs mx-auto">
            <CInputGroupPrepend>
              <CInputGroupText>
                <CIcon name="cil-lock-locked" />
              </CInputGroupText>
            </CInputGroupPrepend>
            <CInput
              type="password"
              placeholder="Password"
              autoComplete="current-password"
              name="password"
              value={values.password}
              onChange={handleChange}
              invalid={errors.password ? true : false}
            />
          </CInputGroup>
        </CCol>
      </CRow>
      <CRow className="d-flex justify-content-between w-75 mx-auto width-xs">
        <LoaderButton
          title="Login"
          loading={loading}
          onClick={handleSubmit}
          type="submit"
        />
        <CButton
          color="link"
          className="px-0 forgot-password"
          onClick={() => {
            setErrorMessage(null);
            setForgotPassword(!forgotPassword);
          }}
        >
          Forgot password?
        </CButton>
      </CRow>
      {errorMessage && (
        <CRow className="mt-3">
          <CCol className="w-75 mx-sm-auto width-xs" md={9}>
            <CAlert color="warning">{errorMessage}</CAlert>
          </CCol>
        </CRow>
      )}
    </CForm>
  );
}

export default LoginForm;
